/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { BrandColors, Checkbox } from '@blend/enterprise-components';
import { WrappedInput } from 'blb-components/WrappedInput';
export const styles = StyleSheet.create({
  fieldWrapper: {
    ':first-child': {
      backgroundColor: BrandColors.CLOUD_10
    },
    ':not(:last-child)': {
      padding: '4px 0'
    }
  }
});
export const getTenantCheckboxConfig = (tenant, onClick) => ({
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    checked: !tenant.isExcluded,
    id: tenant.name,
    onClick
  },
  inputComponent: Checkbox,
  label: `${tenant.displayName} (${tenant.name})`,
  labelPosition: 'right',
  labelSize: 'sm',
  name: tenant.name,
  type: 'checkbox'
});
export const getClosingTypeCheckboxConfig = (closingType, onClick) => ({
  component: WrappedInput,
  containerStyles: [styles.fieldWrapper],
  customComponentProps: {
    checked: !closingType.isExcluded,
    id: closingType.name,
    onClick
  },
  inputComponent: Checkbox,
  label: `${closingType.displayName}`,
  labelPosition: 'right',
  labelSize: 'sm',
  name: closingType.name,
  type: 'checkbox'
});